export const api_getEmailCode = (email: string) => {
  return useHttp("/auth/email/send_code", {
    params: {
      email: "1394941895@qq.com",
    },
  });
};

export const api_innerShareOpenUrl = (id: string) => {
  let baseURL: string = useRuntimeConfig().public.apiBase;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };
  return useCustomizeFetch(baseURL + "/inner/share/open_url?id=" + id, options);
};

/**
 * 获取不同场景登录配置
 * @param scene 场景
 * @returns
 */
export const api_loginConfigsince = (scene: string = "h5") => {
  const params: { [p: string]: any } = {
    scene,
  };
  return useHttp("/system/login_config", {
    params,
  });
};
